<template>
<footer :class="{'minified':minified}">


    <div v-if="minified" class="footer-min">
        <a class="" href="mailto:hello@doctorconsultas.com">Contactanos</a>
        <a class="" href="/terms">Términos y condiciones</a>
        <a class="" href="/privacy">Política de privacidad</a>
        <a class="" href="https://doctorconsultas.com/downloads/tutorial-medicos.php" target="_blank">Descargar manual de uso</a>
        <a class="" href="https://doctorconsultas.com">© 2019 Recetalia</a>
    </div>
    <div v-else class="container margin_60_35">

        <div class="row">
            <div class="col-md-3">
                <a href="index.html" title="Findoctor">
                    <img src="@/assets/img/logo.png" data-retina="true" alt="" width="163" height="36" class="img-fluid">
                </a>
            </div>
            <div class="col-md-6">
                <ul id="additional_links">
                    <li><a class="link_bright" href="/login">Ingresar</a></li>
                    <li><a class="link_bright" href="/register">Registrarme</a></li>
                    <li><a class="link_bright" href="/terms">Términos y condiciones</a></li>
                    <li><a class="link_bright" href="/privacy">Política de privacidad</a></li>
                </ul>
            </div>
            <div class="col-md-3">
                <div id="copy">© 2019 DoctorConsultas</div>
            </div>
        </div>
    </div>
</footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Footer',
    props: ['minified'],
    computed: {
		...mapGetters(['isAuthenticated'])
    },
}
</script>

<style scoped>
/* Footer */
footer {
    background-color: #fff;
    color: #555;
    text-align: left;
}
footer.minified {
    background-color: transparent;
    color: #555;
    text-align: center;
}

footer h5 {
    font-size: 14px;
    font-size: 0.875rem;
    font-weight: 600;
    text-transform: uppercase;
    color: #999;
    margin-bottom: 20px;
}

@media (max-width: 767px) {
    footer h5 {
        /* For less than 767px */
        margin-bottom: 10px;
    }
}

@media (max-width: 767px) {
    footer ul {
        /* For less than 767px */
        margin-bottom: 35px;
    }
}

footer ul li {
    margin-bottom: 10px;
}

footer ul li a {
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    display: inline-block;
    position: relative;
    color: #555555;
    font-weight: 500;
}



footer ul li a i {
    margin-right: 10px;
    color: #fff;
}

footer ul.links li a:hover {
    -webkit-transform: translate(5px, 0);
    -moz-transform: translate(5px, 0);
    -ms-transform: translate(5px, 0);
    -o-transform: translate(5px, 0);
    transform: translate(5px, 0);
}

footer ul.links li a:hover:after {
    opacity: 1;
}

footer ul.links li a:after {
    font-family: 'ElegantIcons';
    content: "\24";
    position: absolute;
    margin-left: 5px;
    top: 1px;
    opacity: 0;
    -moz-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
}


footer #copy {
    text-align: right;
    font-size: 13px;
    font-size: 0.8125rem;
    color: #999;
}

@media (max-width: 767px) {
    footer #copy {
        /* For less than 767px */
        text-align: left;
        margin-bottom: 25px;
    }
}

.follow_us ul {
    margin: 0;
}

.follow_us ul li {
    display: inline-block;
    margin-right: 10px;
    font-size: 16px;
    font-size: 1rem;
}

.follow_us ul li a i {
    color: #555;
}

.follow_us ul li a i:hover {
    color: #e74e84;
}

/* Addtional links / Footer */
ul#additional_links {
    margin: 0;
    font-size: 13px;
    font-size: 0.8125rem;
    color: #999;
}

ul#additional_links li {
    display: inline-block;
    margin-right: 15px;
}

ul#additional_links li:first-child {
    margin-right: 20px;
}

ul#additional_links li:last-child:after {
    content: "";
}

ul#additional_links li a {
    opacity: 0.5;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

ul#additional_links li a:hover {
    opacity: 1;
}

ul#additional_links li:after {
    content: "|";
    font-weight: 300;
    position: relative;
    left: 10px;
}


.footer-min{
    color: #555;
    width: 100%;
    text-align: center;
    padding: 9px 8px;
    font-size: 12px;
}

.footer-min a{
    color: #555;
    margin: 0px 8px;
}



</style>
